<template>
  <div>
    <label class="switch_jovool m-0">
      <input
        class="switch_input"
        type="checkbox"
        v-model="input"
        @click="onClick"
        checked
      />
      <span class="slider_jovool round"></span>
    </label>
    <span class="ml-1 f12">{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
      required: false,
    },
    onClick: {
      type: Function,
      default: function () {},
      required: false,
    },
  },
  data: () => ({
    input: false,
  }),
  mounted() {
    if (this.value) this.input = this.value;
  },
  watch: {
    value() {
      this.input = this.value;
    },
    input() {
      this.$emit("input", this.input);
    },
  },
};
</script>

<style scoped>
.switch_jovool {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.switch_input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider_jovool {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider_jovool:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider_jovool {
  background-color: #4a3383;
}

input:focus + .slider_jovool {
  box-shadow: 0 0 1px #4a3383;
}

input:checked + .slider_jovool:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider_jovool.round {
  border-radius: 34px;
}

.slider_jovool.round:before {
  border-radius: 50%;
}
</style>